import authenticatedApiClient from './authenticatedApiClient';

export async function fetchCurrentSession() {
    const response = await authenticatedApiClient.get('/session');
    return response.data;
}

export async function fetchSecurityAuditStatus() {
    const response = await authenticatedApiClient.get('/security-audit/status');
    return response.data;
}

export async function fetchSecurityAuditEvents(params = {}) {
    const response = await authenticatedApiClient.get('/security-audit/events', { params });
    return response.data;
}
